import { useQuery } from '@tanstack/react-query';

import rateGroupService from '~/services/cruises/RateGroupService';

import { rateGroupQueryKeys } from './rateGroupQueryKeys';

export function useGetRateGroups(vendorId: string | undefined) {
  return useQuery({
    queryKey: rateGroupQueryKeys.list(vendorId),
    queryFn: async () => {
      const response = await rateGroupService.list({ vendorId: vendorId! });
      return response.result;
    },
    enabled: !!vendorId,
    staleTime: Infinity,
  });
}
